export default "icons-pb-menu-toggle"